"use client";

import { useTheme } from '@/contexts/ThemeContext';

export default function LandingVisuals() {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (

        <>
            {/* Background Orbs */}
            <div className={`absolute top-0 left-0 w-[500px] h-[500px] rounded-full blur-[120px] -translate-x-1/2 -translate-y-1/2 pointer-events-none ${isDark ? 'bg-purple-600/20' : 'bg-purple-400/30'}`}></div>
            <div className={`absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full blur-[150px] translate-x-1/3 translate-y-1/3 pointer-events-none ${isDark ? 'bg-blue-600/20' : 'bg-blue-400/25'}`}></div>
            <div className={`absolute top-1/2 left-1/2 w-[400px] h-[400px] rounded-full blur-[100px] -translate-x-1/2 -translate-y-1/2 pointer-events-none ${isDark ? 'bg-pink-600/10' : 'bg-pink-400/15'}`}></div>

            {/* Floating Elements that depend on score/theme */}
            <div className="hidden lg:block absolute top-[20%] right-[10%] z-0 pointer-events-none">
                {/* We're calculating the Resume SVG position in CSS usually, but here we just render the interactive parts if needed.
              Actually, the SVG in the main page used `isDark`. We should probably export the SVG as well if it relies on client state?
              Yes, the SVG used `isDark`. So the SVG needs to be here or receive props.
              Better: Put the SVG here in this client component so it can react to theme.
          */}
            </div>
        </>
    );
}

// We also need the Resume Graphic as a client component because it changes colors based on theme
export function AnimatedResumeGraphic() {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const score = 87;

    return (
        <div className="relative animate-float">
            {/* Resume SVG */}
            <svg width="320" height="420" viewBox="0 0 320 420" className="drop-shadow-2xl">
                {/* Paper Background */}
                <rect x="10" y="10" width="300" height="400" rx="8" fill={isDark ? "#1e1e2e" : "#ffffff"} stroke={isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"} strokeWidth="1" />
                <rect x="10" y="10" width="300" height="400" rx="8" fill="url(#paperGradient)" opacity="0.5" />

                {/* Header Section */}
                <rect x="30" y="30" width="180" height="16" rx="4" fill={isDark ? "rgba(168,85,247,0.4)" : "rgba(168,85,247,0.6)"} />
                <rect x="30" y="54" width="120" height="10" rx="3" fill={isDark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)"} />
                <rect x="30" y="70" width="160" height="8" rx="2" fill={isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"} />

                {/* Profile Circle */}
                <circle cx="260" cy="55" r="30" fill={isDark ? "rgba(59,130,246,0.3)" : "rgba(59,130,246,0.2)"} stroke={isDark ? "rgba(255,255,255,0.2)" : "rgba(59,130,246,0.4)"} strokeWidth="2" />
                <circle cx="260" cy="48" r="10" fill={isDark ? "rgba(255,255,255,0.3)" : "rgba(59,130,246,0.4)"} />
                <ellipse cx="260" cy="68" rx="15" ry="10" fill={isDark ? "rgba(255,255,255,0.3)" : "rgba(59,130,246,0.4)"} />

                {/* Section: Experience */}
                <rect x="30" y="110" width="100" height="12" rx="3" fill={isDark ? "rgba(168,85,247,0.5)" : "rgba(168,85,247,0.7)"} />
                <rect x="30" y="130" width="260" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.08)"} />
                <rect x="30" y="142" width="240" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)"} />
                <rect x="30" y="154" width="250" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)"} />
                <rect x="30" y="166" width="200" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)"} />

                {/* Section: Skills */}
                <rect x="30" y="195" width="60" height="12" rx="3" fill={isDark ? "rgba(59,130,246,0.5)" : "rgba(59,130,246,0.7)"} />
                <rect x="30" y="215" width="50" height="20" rx="10" fill="rgba(168,85,247,0.3)" />
                <rect x="88" y="215" width="65" height="20" rx="10" fill="rgba(59,130,246,0.3)" />
                <rect x="161" y="215" width="45" height="20" rx="10" fill="rgba(236,72,153,0.3)" />
                <rect x="214" y="215" width="55" height="20" rx="10" fill="rgba(34,197,94,0.3)" />
                <rect x="30" y="243" width="60" height="20" rx="10" fill="rgba(249,115,22,0.3)" />
                <rect x="98" y="243" width="70" height="20" rx="10" fill="rgba(168,85,247,0.3)" />

                {/* Section: Education */}
                <rect x="30" y="285" width="80" height="12" rx="3" fill={isDark ? "rgba(34,197,94,0.5)" : "rgba(34,197,94,0.7)"} />
                <rect x="30" y="305" width="220" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.08)"} />
                <rect x="30" y="317" width="180" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)"} />

                {/* Section: Projects */}
                <rect x="30" y="345" width="70" height="12" rx="3" fill={isDark ? "rgba(249,115,22,0.5)" : "rgba(249,115,22,0.7)"} />
                <rect x="30" y="365" width="260" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.06)"} />
                <rect x="30" y="377" width="230" height="6" rx="2" fill={isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)"} />

                {/* Gradient Definition */}
                <defs>
                    <linearGradient id="paperGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="rgba(168,85,247,0.1)" />
                        <stop offset="100%" stopColor="rgba(59,130,246,0.1)" />
                    </linearGradient>
                </defs>
            </svg>

            {/* Floating Score Badge */}
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-2xl bg-gradient-to-br from-green-500 to-emerald-600 flex flex-col items-center justify-center shadow-xl shadow-green-500/30 animate-pulse-slow text-white">
                <span className="text-2xl font-bold">87</span>
                <span className="text-xs opacity-80">ATS Score</span>
            </div>

            {/* Floating Keyword Badge */}
            <div className="absolute top-20 -left-8 px-3 py-2 rounded-lg bg-purple-500/90 text-sm font-medium shadow-lg animate-bounce-slow text-white">
                ✓ Keywords Found
            </div>

            {/* Floating AI Badge */}
            <div className="absolute bottom-24 -right-6 px-3 py-2 rounded-lg bg-blue-500/90 text-sm font-medium shadow-lg animate-bounce-slow text-white" style={{ animationDelay: '0.5s' }}>
                🤖 AI Optimized
            </div>

            {/* Floating Check Badge */}
            <div className="absolute bottom-8 -left-4 px-3 py-2 rounded-lg bg-pink-500/90 text-sm font-medium shadow-lg animate-bounce-slow text-white" style={{ animationDelay: '1s' }}>
                📝 Format OK
            </div>
        </div>
    );
}
